const statuses = [
    'Pending Agent Review',
    'Pending Admin Review',
    'Pending Member Review',
    'Incomplete',
    'Suspended',
    'Approved',
    'Declined'
];

const changeStatusDisplay = [
    'Pending',
    'Incomplete',
    'Suspended'
];

const types = [
    'Edit Member Details',
    'Edit Employment Details',
    'Add a Dependent',
    'Edit Dependent Details',
    'Remove a Dependent',
    'Add Irrevocable Beneficiary',
    'Edit Irrevocable Beneficiary',
    'Remove Irrevocable Beneficiary',
    'Add Revocable Beneficiary',
    'Edit Revocable Beneficiary',
    'Remove Revocable Beneficiary',
    'Add Trustee',
    'Edit Trustee',
    'Remove Trustee',
    'Waive Benefits',
    'Reinstate Benefits'
];


export {
    statuses,
    changeStatusDisplay,
    types
};